export const CustomerTypeMap = {
    0: '未知',
    1: '客户联系人',
    2: '客户经理',
    3: '订单跟进人',
    4: '现场联系人',
    5: '商户联系人',
};